import React, { useState } from "react";
import styles from "../Brands/Brands.module.css";
import brands_Data from "../../Data/RO-landing.json";

const Brands = () => {
  //   const [brands, setBrands] = useState([]);

  let brands = brands_Data[0].brands;
  // console.log(brands);
  return (
    <div className={styles.container}>
      {brands?.map((data, index) => {
        return (
          <>
            <div className={styles.card}>
              <img src={data} alt={data} />
            </div>
          </>
        );
      })}
    </div>
  );
};

export default Brands;
